import { deleteCookie } from 'cookies-next';

import { LoyaltyType } from '@api/index';
import {
  advancePaymentStorageKey,
  activePaymentMethodStorageKey,
} from '@constants/constants';
import { clearLoyalty } from '@hooks/cache/index';
import { callService } from '@api/remote-call';
import {
  BasketHotelAdvancePaymentDetailViewModel,
  BasketViewModel,
} from '@api/v3';

export type AdvancePaymentSupport = {
  isSupported?: boolean;
  advancePaymentDetail?: BasketHotelAdvancePaymentDetailViewModel;
  type?: string;
};

export const checkAdvancePaymentSupport = (basket?: BasketViewModel) => {
  if (!basket) return {};
  const { hotels = [], tours = [], flights = [] } = basket;
  let isSupported = false;
  if (basket.isPackageBasket) {
    isSupported = true;
  } else {
    isSupported =
      (hotels.length === 1 && tours.length === 0 && flights.length === 0) ||
      (hotels.length === 0 && tours.length === 1 && flights.length === 0);
  }
  const advancePaymentDetail =
    hotels[0]?.advancePaymentDetail || tours[0]?.advancePaymentDetail;
  const type = basket.isPackageBasket
    ? 'package'
    : isSupported && hotels.length === 1
    ? 'hotel'
    : 'tour';
  return { isSupported, advancePaymentDetail, type };
};

export const getAdvancePaymentRate = (basket?: BasketViewModel) => {
  return (
    (basket?.hotels?.[0]?.advancePaymentDetail?.rate ||
      basket?.tours?.[0]?.advancePaymentDetail?.rate) ??
    0
  );
};

export const clearBasketStorage = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('basketDetail');
    localStorage.removeItem('basketId');
    deleteCookie('basketId');
    localStorage.removeItem('paymentRequestToken');
    localStorage.removeItem('advanceDeadline');
    localStorage.removeItem('activePaymentMethod');
    localStorage.removeItem(advancePaymentStorageKey);
    localStorage.removeItem(activePaymentMethodStorageKey);
    clearLoyalty(LoyaltyType.HOPI_KAZANIM);
  }
};
export const clearGuestsStorage = () => {
  localStorage.removeItem('guests');
};
export const handleUpdateUserBasketIdLogout = async (basketId) => {
  if (basketId) {
    const basketData = await callService(
      {
        service: 'BasketsService',
        method: 'getBasket',
        version: 'v3',
      },
      { basketId }
    );
    if (basketData?.isLocked) {
      await callService(
        { service: 'BasketsService', method: 'unlock', version: 'v3' },
        {
          basketId,
        }
      );
      await callService(
        {
          service: 'BasketsService',
          method: 'updateBasketUserId',
          version: 'v3',
        },
        { basketId }
      );
    } else {
      await callService(
        {
          service: 'BasketsService',
          method: 'updateBasketUserId',
          version: 'v3',
        },
        { basketId }
      );
    }
    const userIDChangedBasketData = await callService(
      {
        service: 'BasketsService',
        method: 'getBasket',
        version: 'v3',
      },
      { basketId }
    );
    if (userIDChangedBasketData) {
      localStorage.setItem(
        'basketDetail',
        JSON.stringify(userIDChangedBasketData)
      );
    }
  }
};
